/// <amd-module name="VSSUI/Components/DateTimeRangePicker/DateTimeRangePicker" />

import * as React from "react";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";
import { IDateTimeRangePickerProps } from "../../Components/DateTimeRangePicker/DateTimeRangePicker.Props";
import { DateTimePicker } from "../../DateTimePicker";

import "VSS/LoaderPlugins/Css!VSSUI/Components/DateTimeRangePicker/DateTimeRangePicker";

/** @deprecated */
export interface DateTimeRangePickerState {}

function min(a?: Date, b?: Date): Date | undefined {
    if (!a) {
        return b;
    }
    if (!b) {
        return a;
    }
    return a < b ? a : b;
}

function max(a?: Date, b?: Date): Date | undefined {
    if (!a) {
        return b;
    }
    if (!b) {
        return a;
    }
    return a > b ? a : b;
}

/** @deprecated */
export class DateTimeRangePicker extends React.Component<IDateTimeRangePickerProps, DateTimeRangePickerState> {
    private _startTime?: Date;
    private _endTime?: Date;

    constructor(props: IDateTimeRangePickerProps) {
        super(props);

        if (props) {
            this._startTime = props.defaultStartTime;
            this._endTime = props.defaultEndTime;
        }
    }

    public render(): JSX.Element {
        const { maxDate, minDate } = this.props;
        return (
            <div className="vss-DateTimeRangePicker">
                <div className="vss-DateTimeRangePicker--container">
                    <span className="vss-DateTimeRangePicker--label">{Resources.DateTimeRangePicker_Start}</span>
                    <DateTimePicker
                        dateFieldClassName="startDate"
                        timeFieldClassName="startTime"
                        defaultValue={this._startTime}
                        maxDate={min(maxDate, this._endTime)}
                        minDate={minDate}
                        disableAutoFocus
                        formatDate={this.props.formatDate}
                        formatTime={this.props.formatTime}
                        parseTimeFromString={this.props.parseTimeFromString}
                        onValueChanged={(date: Date) => {
                            this._startTime = date;
                            if (this.props.onValueChanged) {
                                this.props.onValueChanged(this._startTime, this._endTime);
                            }
                        }}
                        dateAriaLabel={this.props.startDateAriaLabel || Resources.DateTimeRangePicker_StartDate}
                        timeAriaLabel={this.props.startTimeAriaLabel || Resources.DateTimeRangePicker_StartTime}
                    />
                </div>
                <div className="vss-DateTimeRangePicker--container">
                    <span className="vss-DateTimeRangePicker--label">{Resources.DateTimeRangePicker_End}</span>
                    <DateTimePicker
                        dateFieldClassName="endDate"
                        timeFieldClassName="endTime"
                        defaultValue={this._endTime}
                        maxDate={maxDate}
                        minDate={max(minDate, this._startTime)}
                        disableAutoFocus
                        formatDate={this.props.formatDate}
                        formatTime={this.props.formatTime}
                        parseTimeFromString={this.props.parseTimeFromString}
                        onValueChanged={(date: Date) => {
                            this._endTime = date;
                            if (this.props.onValueChanged) {
                                this.props.onValueChanged(this._startTime, this._endTime);
                            }
                        }}
                        dateAriaLabel={this.props.endDateArialLabel || Resources.DateTimeRangePicker_EndDate}
                        timeAriaLabel={this.props.endTimeAriaLabel || Resources.DateTimeRangePicker_EndTime}
                    />
                </div>
            </div>
        );
    }
}
